import { observer } from 'mobx-react';
import { autoinject, bind, inject } from 'Mri.Web.Common';
import * as React from 'react';
import { BsBoxArrowRight } from '@react-icons/all-files/bs/BsBoxArrowRight';
import { BsFillPersonFill } from '@react-icons/all-files/bs/BsFillPersonFill';
import { BsFillQuestionCircleFill } from '@react-icons/all-files/bs/BsFillQuestionCircleFill';
import { BsGearFill } from '@react-icons/all-files/bs/BsGearFill';
import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';
import { Link } from 'react-router-dom';
import { DropdownItem, DropdownMenu, DropdownToggle, UncontrolledButtonDropdown } from 'reactstrap';
import { AccountStore } from '../Account/AccountStore';

@autoinject
@observer
export class UserMenu extends React.Component {
    public render() {
        const { isLoggedIn, user } = this.accountStore;

        if (isLoggedIn && user) {
            return (
                <UncontrolledButtonDropdown>
                    <DropdownToggle color="link">
                        <BsFillPersonFill style={{ fontSize: 22 }} />
                    </DropdownToggle>
                    <DropdownMenu end className="p-0 dropdown-padding">
                        <DropdownItem className="py-0 border-bottom" disabled>
                            <small>{user.userName}</small>
                        </DropdownItem>

                        <DropdownItem tag={Link} to="/preferences" className="fw-bold py-0">
                            <BsGearFill style={{ marginRight: 6 }} />
                            Preferences
                        </DropdownItem>

                        <DropdownItem tag="a" href="https://support.mri-inc.net" className="fw-bold py-0">
                            <BsFillQuestionCircleFill style={{ marginRight: 6 }} />
                            Help Center
                        </DropdownItem>

                        {user.isImpersonating && (
                            <DropdownItem onClick={this.logout} className="text-danger fw-bold py-0">
                                <BsXCircle style={{ marginRight: 6 }} />
                                Stop Impersonating
                            </DropdownItem>
                        )}

                        <DropdownItem onClick={this.logout} className="fw-bold py-0 border-top ">
                            <BsBoxArrowRight style={{ marginRight: 6, fontSize: 20 }} />
                            Logout
                        </DropdownItem>
                    </DropdownMenu>
                </UncontrolledButtonDropdown>
            );
        } else {
            return (
                <a href="/account/login" className="btn-link d-block px-5 text-header float-end h-100 fw-bold">
                    Login
                </a>
            );
        }
    }

    @bind
    private logout(event: React.MouseEvent<HTMLButtonElement>) {
        if (typeof sessionStorage != 'undefined') sessionStorage.clear();
        if (typeof localStorage != 'undefined') localStorage.clear();
        this.accountStore!.signoutRedirect();
    }

    @inject
    private readonly accountStore!: AccountStore;
}
